enum FormFields {
  Email = 'email',
  IsPasswordShown = 'isPasswordShown',
  Password = 'password',
}

const FormFieldsList = [
  FormFields.Email,
  FormFields.IsPasswordShown,
  FormFields.Password,
];

export { FormFields, FormFieldsList };
